import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';

export function ApiSelectionModalTaC(props) {
    const { content } = props;
    const classes = useStyles(props);

    return (
        <div
            className={classes.content}
            dangerouslySetInnerHTML={{ __html: content }}
        />
    );
}

const useStyles = makeStyles(
    theme => ({
        content: {
            overflow: 'scroll',
        },
    }),
    {
        name: 'Layer7ApplicationApiSelectionModalTaC',
    }
);
